// extracted by mini-css-extract-plugin
export var alignCenter = "_8d-d";
export var bannerShown = "_8d-6";
export var buttonContent = "_8d-0";
export var cardList = "_8d-1";
export var centerContent = "_8d-2";
export var chevron = "_8d-3";
export var closePanelButton = "_8d-k";
export var conversationContextContainer = "_8d-l";
export var conversationDetailContainer = "_8d-4";
export var detailWrapper = "_8d-7";
export var dropdownButton = "_8d-e";
export var dropdownTitle = "_8d-9";
export var fullHeight = "_8d-5";
export var hidden = "_8d-a";
export var icon = "_8d-b";
export var mergeSuggestionWrapper = "_8d-m";
export var panel = "_8d-i";
export var portalButtonsWrapper = "_8d-c";
export var right = "_8d-j";
export var tableSummaryContainer = "_8d-8";
export var tableSummaryHeader = "_8d-g";
export var threeDotsButton = "_8d-f";
export var wide = "_8d-h";